/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateMqttUserDto,
  MqttUsersControllerDeleteV1PathParameters,
  MqttUsersControllerFindOneV1PathParameters,
  MqttUsersControllerUpdateV1PathParameters,
  UpdateMqttUserDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class MqttUsersService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Create a new MQTT user
   */

  create<TData = void>(createMqttUserDto: CreateMqttUserDto): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/mqtt-users`, createMqttUserDto);
  }
  /**
   * @summary Get all MQTT users
   */

  findAll<TData = void>(): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/mqtt-users`);
  }
  /**
   * @summary Get a MQTT user by id
   */

  findOne<TData = void>({ id }: MqttUsersControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/mqtt-users/${id}`);
  }
  /**
   * @summary Update a MQTT user
   */

  update<TData = void>({ id }: MqttUsersControllerUpdateV1PathParameters, updateMqttUserDto: UpdateMqttUserDto): Observable<TData> {
    return this.http.patch<TData>(`/clients/v1/mqtt-users/${id}`, updateMqttUserDto);
  }
  /**
   * @summary Delete a MQTT user
   */

  delete<TData = void>({ id }: MqttUsersControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/clients/v1/mqtt-users/${id}`);
  }
}
